export const folderKeys = {
  all: ['folders'] as const,
  lists: () => [...folderKeys.all, 'list'] as const,
  listWithItems: () => [...folderKeys.lists(), 'items'] as const,
  listSearch: () => [...folderKeys.lists(), 'search'] as const,
  details: () => [...folderKeys.all, 'detail'] as const,
  playNext: () => [...folderKeys.all, 'play-next'] as const,
  detail: (id: string) => [...folderKeys.details(), { id }] as const,
} as const;
